<template>
  <!-- Main content -->
  <section class="content">
    <!-- Main row -->
    <div class="row">
       <!-- Info boxes -->
      <div class="col-md-4 col-sm-6 col-xs-12">
        <info-box color-class="bg-aqua dash-boxx"
                  :icon-classes="['fa', 'fa-users']"
                  text="Total Users"
                  :number='this.dashboardWidgetDetails.users'></info-box>
      </div>

      <div class="col-md-4 col-sm-6 col-xs-12">
        <info-box color-class="bg-aqua dash-boxx"
                  :icon-classes="['fa', 'fa-product-hunt']"
                  text="Products"
                  :number='this.dashboardWidgetDetails.products'></info-box>
      </div>

      <div class="col-md-4 col-sm-6 col-xs-12">
        <info-box color-class="bg-aqua dash-boxx"
                  :icon-classes="['fa', 'fa-video-camera']"
                  text="Videos"
                  :number='this.dashboardWidgetDetails.videos'></info-box>
      </div>

      <div class="col-md-4 col-sm-6 col-xs-12">
        <info-box color-class="bg-aqua dash-boxx"
                  :icon-classes="['fa', 'fa-file-pdf-o']"
                  text="Documents"
                  :number='this.dashboardWidgetDetails.documents'></info-box>
      </div>

      <div class="col-md-4 col-sm-6 col-xs-12">
        <info-box color-class="bg-aqua dash-boxx"
                  :icon-classes="['fa', 'fa-mobile']"
                  text="Active Mobile Users"
                  :number='this.dashboardWidgetDetails.mobile_users'></info-box>
      </div>

      <div class="col-md-4 col-sm-6 col-xs-12">
        <info-box color-class="bg-aqua dash-boxx"
                  :icon-classes="['fa', 'fa-globe']"
                  text="Active Web Users"
                  :number='this.liveUsers'></info-box>
      </div>
      <!-- /.col -->
    </div>
    <div class="row">
      <div class="col-md-12">
      <div class="box">
        <div class="box-header">
          <h3 class="box-title pull-right">
            <button type="button" @click="logInGoogle()" alt="To access Google Analytics" class="btn primary-btn-my">Authenticate with Google</button>
          </h3>
        </div>
        <!-- /.box-header -->
        <div class="box-body">
      <div class="col-sm-6 col-xs-12">
        <md-card>
          <md-card-header>Live geographic location</md-card-header>
          <md-card-content>
            <table class="table table-dark">
              <thead>
              <tr>
<!--                <th scope="col">#</th>-->
                <th scope="col">Country</th>
                <th scope="col">Number of Users</th>
              </tr>
              </thead>
              <tbody>
              <tr  v-for="country in liveCountryVisitors.rows">
                <td>{{country[0]}}</td>
                <td>{{country[1]}}</td>
              </tr>
              </tbody>
            </table>
          </md-card-content>
        </md-card>
      </div>
      <div class="col-sm-6 col-xs-12">
        <md-card>
          <md-card-header>Type of content been viewed</md-card-header>
          <md-card-content>
            <table class="table table-dark">
              <thead>
              <tr>
                <!--                <th scope="col">#</th>-->
                <th scope="col">Path</th>
                <th scope="col">Content been viewed</th>
              </tr>
              </thead>
              <tbody>
              <tr  v-for="content in liveContentVisitors.rows">
                <td>{{content[0]}}</td>
                <td>{{content[1]}}</td>
              </tr>
              </tbody>
            </table>
          </md-card-content>
        </md-card>
      </div>
        </div>
    </div>
    </div>
    </div>

    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>
<!--<i class="fa fa-users"></i>-->
<script>
  import Alert from '../../widgets/Alert'
  import InfoBox from '../../widgets/InfoBox'
  import ProcessInfoBox from '../../widgets/ProcessInfoBox'
  import SmallBox from '../../widgets/SmallBox'
  import api from '../../../api'

  export default {
    name: 'Dashboard',
    components: {
      Alert,
      InfoBox,
      ProcessInfoBox,
      SmallBox
    },
    data() {
      return {
        dashboardWidgetDetails: {},
        interval: null,
        liveCountryVisitors: {
          rows: []
        },
        liveContentVisitors: {
          rows: []
        },
        liveUsers: '',
        googleGaCode: '211826045',
        googleAccessToken: ''
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.getDashboardWidgetDetails()
        this.updateLiveUsers()
        this.updateLiveCountryUsers()
        this.updateLiveContentUsers()
      })
    },
    methods: {
      logInGoogle() {
        if (this.$auth.getGoogleToken() == null) {
          var ref = this
          this.interval = setInterval(function () {
            ref.updateLiveUsers()
            ref.updateLiveCountryUsers()
            ref.updateLiveContentUsers()
          }, 30000)
          window.location.replace('https://api.rcpanz.com.au/api/auth/google')
        }
      },
      getDashboardWidgetDetails() {
        api.request('get', '/admin/dashboard', false)
          .then(response => {
            if (response.status === 200) {
              this.dashboardWidgetDetails = response.data.result
              this.dashboardWidgetDetails.web_users = 0
              this.dashboardWidgetDetails.mobile_users = 0
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            this.$auth.destroyToken()
          })
      },
      updateLiveUsers() {
        var ref = this
        api.httpRequest('get', 'https://www.googleapis.com/analytics/v3/data/realtime?ids=ga%3A' + this.googleGaCode + '&metrics=rt:activeUsers&access_token=' + this.$auth.getGoogleToken())
          .then(response => {
            if (response) {
              // console.log(response.data.totalsForAllResults['rt:activeUsers'])
              ref.liveUsers = response.data.totalsForAllResults['rt:activeUsers']
            }
            // eslint-disable-next-line handle-callback-err
          }).catch(error => {
          // eslint-disable-next-line no-undef
          //   toast.fire({icon: 'error', title: error})
            if (this.$auth.getGoogleToken()) {
              this.$auth.removeGoogleToken()
              window.location.replace('http://api.rcpanz.com.au/api/auth/google')
            }
          })
      },
      updateLiveCountryUsers() {
        var ref = this
        api.httpRequest('get', 'https://www.googleapis.com/analytics/v3/data/realtime?ids=ga%3A' + this.googleGaCode + '&metrics=rt:activeUsers&dimensions=rt:country&access_token=' + this.$auth.getGoogleToken())
          .then(response => {
            if (response) {
              ref.liveCountryVisitors = response.data
            }
            // eslint-disable-next-line handle-callback-err
          }).catch(error => {
          // eslint-disable-next-line no-undef
          //   toast.fire({icon: 'error', title: error})
          })
      },
      updateLiveContentUsers() {
        var ref = this
        api.httpRequest('get', 'https://www.googleapis.com/analytics/v3/data/realtime?ids=ga%3A' + this.googleGaCode + '&metrics=rt:activeUsers&dimensions=rt:pagePath&access_token=' + this.$auth.getGoogleToken())
          .then(response => {
            if (response) {
              ref.liveContentVisitors = response.data
            }
            // eslint-disable-next-line handle-callback-err
          }).catch(error => {
          // eslint-disable-next-line no-undef
          //   toast.fire({icon: 'error', title: error})
          })
      }
    },
    created() {
      if (this.$route.query.token) {
        this.$auth.setGoogleToken(this.$route.query.token)
        this.$router.push('/admin/overview')
      }
      // setTimeout(() => (this.logInGoogle()), 2000)
      // var ref = this
      // this.interval = setInterval(function () {
      //   ref.updateLiveUsers()
      //   ref.updateLiveCountryUsers()
      //   ref.updateLiveContentUsers()
      // }, 30000)
    },
    beforeDestroy() {
      clearInterval(this.interval)
    }
  }
</script>
<style>

  .info-box-content {
    text-align: center;
    vertical-align: middle;
    display: inherit;
  }

  .fullCanvas {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?081357b8